import IndicadoresAps from '../pages/IndicadoresAps/IndicadoresAps'

import IndicadorCitologico from '../pages/IndicadoresAps/IndicadorCitologico/IndicadorCitologico'
import IndicadorCitologicoPorEquipeAcs from '../pages/IndicadoresAps/IndicadorCitologico/PorEquipeAcs'
import IndicadorCitologicoPorProfissional from '../pages/IndicadoresAps/IndicadorCitologico/PorProfissional'

import IndicadorImunizacao from '../pages/IndicadoresAps/IndicadorImunizacao/IndicadorImunizacao'
import IndicadorImunizacaoPorEquipeAcs from '../pages/IndicadoresAps/IndicadorImunizacao/PorEquipeAcs'
import IndicadorImunizacaoPorProfissional from '../pages/IndicadoresAps/IndicadorImunizacao/PorProfissional'

import PreNatal from '../pages/IndicadoresAps/PreNatal/Index.vue'
import ConsultasPreNatal from '../pages/IndicadoresAps/PreNatal/ConsultasPreNatal/ConsultasPreNatal'
import ConsultasPreNatalPorEquipeAcs from '../pages/IndicadoresAps/PreNatal/ConsultasPreNatal/PorEquipeAcs'
import ConsultasPreNatalPorProfissional from '../pages/IndicadoresAps/PreNatal/ConsultasPreNatal/PorProfissional'

import ConsultasOdontologicas from '../pages/IndicadoresAps/PreNatal/ConsultasOdontologicas/ConsultasOdontologicas'
import ConsultasOdontologicasPorEquipeAcs from '../pages/IndicadoresAps/PreNatal/ConsultasOdontologicas/PorEquipeAcs'
import ConsultasOdontologicasPorProfissional from '../pages/IndicadoresAps/PreNatal/ConsultasOdontologicas/PorProfissional'

import ExamesHivSifilis from '../pages/IndicadoresAps/PreNatal/ExamesHivSifilis/ExamesHivSifilis'
import ExamesHivSifilisPorEquipeAcs from '../pages/IndicadoresAps/PreNatal/ExamesHivSifilis/PorEquipeAcs'
import ExamesHivSifilisPorProfissional from '../pages/IndicadoresAps/PreNatal/ExamesHivSifilis/PorProfissional'

import DoencasCronicas from '../pages/IndicadoresAps/DoencasCronicas/Index.vue'
import HemoglobinaGlicada from '../pages/IndicadoresAps/DoencasCronicas/HemoglobinaGlicada/HemoglobinaGlicada'
import HemoglobinaGlicadaPorEquipeAcs from '../pages/IndicadoresAps/DoencasCronicas/HemoglobinaGlicada/PorEquipeAcs'
import HemoglobinaGlicadaPorProfissional from '../pages/IndicadoresAps/DoencasCronicas/HemoglobinaGlicada/PorProfissional'

import AtendimentoHipertensao from '../pages/IndicadoresAps/DoencasCronicas/AtendimentoHipertensao/AtendimentoHipertensao'
import AtendimentoHipertensaoPorEquipeAcs from '../pages/IndicadoresAps/DoencasCronicas/AtendimentoHipertensao/PorEquipeAcs'
import AtendimentoHipertensaoPorProfissional from '../pages/IndicadoresAps/DoencasCronicas/AtendimentoHipertensao/PorProfissional'

import HiperDia from '../pages/IndicadoresAps/DoencasCronicas/HiperDia/HiperDia'
import HiperDiaPorEquipeAcs from '../pages/IndicadoresAps/DoencasCronicas/HiperDia/PorEquipeAcs'
import HiperDiaPorProfissional from '../pages/IndicadoresAps/DoencasCronicas/HiperDia/PorProfissional'

import ProblemasAtivosPorEquipe from '../pages/IndicadoresAps/PreNatal/ProblemasAtivos/PorEquipe'

import ResultadoIndicadores from '../pages/IndicadoresAps/ResultadoIndicadores/ResultadoIndicadores'

import ResultadoIsfAcs from '../pages/IndicadoresAps/ResultadoIsf/ResultadoIsfAcs'

import TresIndicadoresPreNatalPorEquipe from '../pages/IndicadoresAps/PreNatal/TresIndicadoresPreNatal/PorEquipe'

import BuscaAtiva from '../pages/IndicadoresAps/BuscaAtiva/BuscaAtiva'
import BuscaAtivaPorEquipeAcs from '../pages/IndicadoresAps/BuscaAtiva/PorEquipeAcs'

import DesempenhoPorEquipe from '../pages/IndicadoresAps/DesempenhoPorEquipe'
import DesempenhoPorEquipeGeral from '../pages/IndicadoresAps/DesempenhoPorEquipe/Geral'
import DesempenhoPorEquipePorIndicador from '../pages/IndicadoresAps/DesempenhoPorEquipe/PorIndicador'

export default [
  {
    path: '/indicadores-aps',
    component: IndicadoresAps,
  },
  {
    path: '/indicador-citologico',
    component: () =>
      import('@/pages/IndicadoresAps/IndicadorCitologico/Template.vue'),
    children: [
      {
        path: '/indicador-citologico',
        component: IndicadorCitologico,
      },
      {
        path: '/indicador-citologico/equipe/acs',
        component: IndicadorCitologicoPorEquipeAcs,
      },
      {
        path: '/indicador-citologico/profissional',
        component: IndicadorCitologicoPorProfissional,
      },
    ],
  },
  {
    path: '/indicador-imunizacao',
    component: () =>
      import('@/pages/IndicadoresAps/IndicadorImunizacao/Template.vue'),
    children: [
      {
        path: '/indicador-imunizacao',
        component: IndicadorImunizacao,
      },
      {
        path: '/indicador-imunizacao/equipe/acs',
        component: IndicadorImunizacaoPorEquipeAcs,
      },
      {
        path: '/indicador-imunizacao/profissional',
        component: IndicadorImunizacaoPorProfissional,
      },
    ],
  },
  {
    path: '/pre-natal',
    component: PreNatal,
  },
  {
    path: '/consultas-pre-natal',
    component: () =>
      import('@/pages/IndicadoresAps/PreNatal/ConsultasPreNatal/Template.vue'),
    children: [
      {
        path: '/consultas-pre-natal',
        component: ConsultasPreNatal,
      },
      {
        path: '/consultas-pre-natal/equipe/acs',
        component: ConsultasPreNatalPorEquipeAcs,
      },
      {
        path: '/consultas-pre-natal/profissional',
        component: ConsultasPreNatalPorProfissional,
      },
    ],
  },
  {
    path: '/consultas-odontologicas',
    component: () =>
      import(
        '@/pages/IndicadoresAps/PreNatal/ConsultasOdontologicas/Template.vue'
      ),
    children: [
      {
        path: '/consultas-odontologicas',
        component: ConsultasOdontologicas,
      },
      {
        path: '/consultas-odontologicas/equipe/acs',
        component: ConsultasOdontologicasPorEquipeAcs,
      },
      {
        path: '/consultas-odontologicas/profissional',
        component: ConsultasOdontologicasPorProfissional,
      },
    ],
  },
  {
    path: '/exames-hiv-sifilis',
    component: () =>
      import('@/pages/IndicadoresAps/PreNatal/ExamesHivSifilis/Template.vue'),
    children: [
      {
        path: '/exames-hiv-sifilis',
        component: ExamesHivSifilis,
      },
      {
        path: '/exames-hiv-sifilis/equipe/acs',
        component: ExamesHivSifilisPorEquipeAcs,
      },
      {
        path: '/exames-hiv-sifilis/profissional',
        component: ExamesHivSifilisPorProfissional,
      },
    ],
  },
  {
    path: '/doencas-cronicas',
    component: DoencasCronicas,
  },
  {
    path: '/hemoglobina-glicada',
    component: () =>
      import(
        '@/pages/IndicadoresAps/DoencasCronicas/HemoglobinaGlicada/Template.vue'
      ),
    children: [
      {
        path: '/hemoglobina-glicada',
        component: HemoglobinaGlicada,
      },
      {
        path: '/hemoglobina-glicada/equipe/acs',
        component: HemoglobinaGlicadaPorEquipeAcs,
      },
      {
        path: '/hemoglobina-glicada/profissional',
        component: HemoglobinaGlicadaPorProfissional,
      },
    ],
  },
  {
    path: '/atendimento-hipertensao',
    component: () =>
      import(
        '@/pages/IndicadoresAps/DoencasCronicas/AtendimentoHipertensao/Template.vue'
      ),
    children: [
      {
        path: '/atendimento-hipertensao',
        component: AtendimentoHipertensao,
      },
      {
        path: '/atendimento-hipertensao/equipe/acs',
        component: AtendimentoHipertensaoPorEquipeAcs,
      },
      {
        path: '/atendimento-hipertensao/profissional',
        component: AtendimentoHipertensaoPorProfissional,
      },
    ],
  },
  {
    path: '/hiper-dia',
    component: () =>
      import('@/pages/IndicadoresAps/DoencasCronicas/HiperDia/Template.vue'),
    children: [
      {
        path: '/hiper-dia',
        component: HiperDia,
      },
      {
        path: '/hiper-dia/equipe/acs',
        component: HiperDiaPorEquipeAcs,
      },
      {
        path: '/hiper-dia/profissional',
        component: HiperDiaPorProfissional,
      },
    ],
  },
  {
    path: '/problemas-ativos',
    component: () =>
      import('@/pages/IndicadoresAps/PreNatal/ProblemasAtivos/Template.vue'),
    children: [
      {
        path: '/problemas-ativos/equipe',
        component: ProblemasAtivosPorEquipe,
      },
    ],
  },
  {
    path: '/resultado-indicadores',
    component: ResultadoIndicadores,
  },
  {
    path: '/resultado-isf-acs',
    component: ResultadoIsfAcs,
  },
  {
    path: '/tres-indicadores-pre-natal',
    component: () =>
      import(
        '@/pages/IndicadoresAps/PreNatal/TresIndicadoresPreNatal/Template.vue'
      ),
    children: [
      {
        path: '/tres-indicadores-pre-natal/equipe/acs',
        component: TresIndicadoresPreNatalPorEquipe,
      },
    ],
  },
  {
    path: '/busca-ativa',
    component: () => import('@/pages/IndicadoresAps/BuscaAtiva/Template.vue'),
    children: [
      {
        path: '/busca-ativa',
        component: BuscaAtiva,
      },
      {
        path: '/busca-ativa/equipe/acs',
        component: BuscaAtivaPorEquipeAcs,
      },
    ],
  },
  {
    path: '/desempenho-por-equipe',
    component: DesempenhoPorEquipe,
  },
  {
    path: '/desempenho',
    component: () =>
      import('@/pages/IndicadoresAps/DesempenhoPorEquipe/Template.vue'),
    children: [
      {
        path: '/desempenho-por-equipe/geral',
        component: DesempenhoPorEquipeGeral,
      },
      {
        path: '/desempenho-por-equipe/indicador',
        component: DesempenhoPorEquipePorIndicador,
      },
    ],
  },
  {
    path: '/primeira-consulta-programada',
    component: () =>
      import('@/pages/IndicadoresAps/PrimeiraConsultaProgramada/Template.vue'),
    children: [
      {
        path: '/primeira-consulta-programada',
        component: () =>
          import('@/pages/IndicadoresAps/PrimeiraConsultaProgramada/Index.vue'),
      },
    ],
  },
  {
    path: '/tratamentos-concluidos',
    component: () =>
      import('@/pages/IndicadoresAps/TratamentosConcluidos/Template.vue'),
    children: [
      {
        path: '/tratamentos-concluidos',
        component: () =>
          import('@/pages/IndicadoresAps/TratamentosConcluidos/Index.vue'),
      },
    ],
  },
  {
    path: '/exodontias',
    component: () => import('@/pages/IndicadoresAps/Exodontias/Template.vue'),
    children: [
      {
        path: '/exodontias',
        component: () => import('@/pages/IndicadoresAps/Exodontias/Index.vue'),
      },
    ],
  },
  {
    path: '/escovacao-supervisionada',
    component: () =>
      import('@/pages/IndicadoresAps/EscovacaoSupervisionada/Template.vue'),
    children: [
      {
        path: '/escovacao-supervisionada',
        component: () =>
          import('@/pages/IndicadoresAps/EscovacaoSupervisionada/Index.vue'),
      },
    ],
  },
  {
    path: '/proporcao-procedimentos-preventivos',
    component: () =>
      import(
        '@/pages/IndicadoresAps/ProporcaoProcedimentosPreventivos/Template.vue'
      ),
    children: [
      {
        path: '/proporcao-procedimentos-preventivos',
        component: () =>
          import(
            '@/pages/IndicadoresAps/ProporcaoProcedimentosPreventivos/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/tratamentos-restauradores-art',
    component: () =>
      import('@/pages/IndicadoresAps/TratamentosRestauradoresArt/Template.vue'),
    children: [
      {
        path: '/tratamentos-restauradores-art',
        component: () =>
          import(
            '@/pages/IndicadoresAps/TratamentosRestauradoresArt/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/cuidado-compartilhado',
    component: () =>
      import('@/pages/IndicadoresAps/CuidadoCompartilhado/Template.vue'),
    children: [
      {
        path: '/cuidado-compartilhado',
        component: () =>
          import('@/pages/IndicadoresAps/CuidadoCompartilhado/Index.vue'),
      },
    ],
  },
  {
    path: '/acoes-interprofissionais',
    component: () =>
      import('@/pages/IndicadoresAps/AcoesInterprofissionais/Template.vue'),
    children: [
      {
        path: '/acoes-interprofissionais',
        component: () =>
          import('@/pages/IndicadoresAps/AcoesInterprofissionais/Index.vue'),
      },
    ],
  },
  {
    path: '/comunicacao-emulti-e-equipes',
    component: () =>
      import('@/pages/IndicadoresAps/ComunicacaoEmultiEquipes/Template.vue'),
    children: [
      {
        path: '/comunicacao-emulti-e-equipes',
        component: () =>
          import('@/pages/IndicadoresAps/ComunicacaoEmultiEquipes/Index.vue'),
      },
    ],
  },
  {
    path: '/resolutividade-cuidado-emulti',
    component: () =>
      import('@/pages/IndicadoresAps/ResolutividadeCuidadoEmulti/Template.vue'),
    children: [
      {
        path: '/resolutividade-cuidado-emulti',
        component: () =>
          import(
            '@/pages/IndicadoresAps/ResolutividadeCuidadoEmulti/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/saude-da-mulher',
    component: () =>
      import('@/pages/IndicadoresAps/SaudeDaMulher/Template.vue'),
    children: [
      {
        path: '/saude-da-mulher',
        component: () =>
          import('@/pages/IndicadoresAps/SaudeDaMulher/Index.vue'),
      },
    ],
  },
  {
    path: '/pessoa-idosa',
    component: () => import('@/pages/IndicadoresAps/PessoaIdosa/Template.vue'),
    children: [
      {
        path: '/pessoa-idosa',
        component: () => import('@/pages/IndicadoresAps/PessoaIdosa/Index.vue'),
      },
    ],
  },
]
